export function shouldShowPropertyListExport(propertyCount: number): boolean {
  return propertyCount > 0
}
